import Table, { ColumnProps } from './Table'
import Phone from './Phone'
import { IconContactSupport } from './Icons/IconContactSupport'
import { always, times, filter, prop, pipe } from 'ramda'
import { getAbilityPromise } from '../defineAbility'
import { Badge } from './Badge'
import $ from 'jquery'
import 'bootstrap/js/dist/tooltip'
import { IconInfo } from './Icons/IconInfo'

/** @type { import('@casl/ability').Ability } */
let ability
getAbilityPromise.then((_ability) => ability = _ability)
const canViewRequestField = field => ability.can('view', 'Request', field)
const dataIndex = prop('dataIndex')
const canViewColumn = pipe(
	dataIndex,
	canViewRequestField
)

const RequestLink = {
	props: ColumnProps,
	mounted() {
		this.$watch('record', (record, oldRecord) => {
			$(this.$refs.reports).tooltip('dispose')

			if (!record.REPORTS?.length)
				return

			$(this.$refs.reports).tooltip({ trigger: 'hover' })
		}, { immediate: true })
	},
	render(h) {
		return (
			<span class="text-nowrap">
				<a
					class="request-edit-link"
					href={ `/personal/requests/${this.value}/` }
					target="_blank"
				>
					{ this.value }
				</a>
				{ this.record.REPORTS.length ? (
					<IconInfo
						class="ml-1"
						ref="reports"
						title={ `Отчеты: ${this.record.REPORTS.join(', ')}`}
						fill="#009996"
						width="13"
						height="13"
					/>
				) : null }
			</span>
		)
	},
}

const Acts = ({ props: { value }}) => times(always(<IconContactSupport fill="#009996" />), value)

const RequestStatus = ({ props: { value }}) => (
	<Badge
		text={ value['NAME'] }
		color={ value['COLOR_TEXT'] }
		background={ value['COLOR_BACKGROUND'] }
	/>
)

const Checkbox =  {
	props: ColumnProps,
	render(h) {
		return (<label class="checkbox-block" style="min-width: 20px">
				<input class="checkbox-block__input" name="MASS_UPDATE" type="checkbox" value={this.record.NAME}/>
				<svg class="checkbox checkbox-block__checkbox" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><rect class="checkbox__indeterminate-check" x="4" y="4" width="10" height="10"></rect><path class="checkbox__check" d="M13.8912 4.36181C14.3736 3.8794 15.1558 3.8794 15.6382 4.36181C16.1206 4.84422 16.1206 5.62637 15.6382 6.10878L8.22643 13.5205C7.74401 14.003 6.96187 14.003 6.47946 13.5205L2.36181 9.4029C1.8794 8.92048 1.8794 8.13834 2.36181 7.65593C2.84422 7.17351 3.62637 7.17351 4.10878 7.65593L7.35294 10.9001L13.8912 4.36181Z"></path></svg>
		</label>
		)
	},
}

const columns = [
	{
		name: '',
		dataIndex: 'MASS_UPDATE',
		render: Checkbox,
	},
	{
		name: 'ID',
		dataIndex: 'NAME',
		render: RequestLink,
	},
	{
		name: 'Город',
		dataIndex: 'CITY',
	},
	{
		dataIndex: 'ACTS',
		render: Acts,
	},
	{
		name: 'Статус',
		dataIndex: 'STATUS',
		render: RequestStatus,
	},
	{
		name: 'Имя пользователя',
		dataIndex: 'FULL_NAME',
	},
	{
		name: 'Телефон',
		dataIndex: 'PHONE',
		render: Phone,
	},
	{
		name: 'Производитель',
		dataIndex: 'BRAND',
	},
	{
		name: 'Модель',
		dataIndex: 'MODEL',
	},
	{
		name: 'Серийный номер',
		dataIndex: 'SERIAL_NUMBER',
	},
	{
		name: 'Трек номер',
		dataIndex: 'TRACKS',
	},
]

export const CustomTable = ({ data, slots }) => (
	<div class="request-table overflow-x-auto">
		<table { ...data }>
			{ slots().default }
		</table>
	</div>
)
CustomTable.name = 'CustomTable';

export const CustomHeaderRow = ({ slots }) => (
	<tr class="request-table_header">
		{ slots().default }
	</tr>
)
CustomHeaderRow.name = 'CustomHeaderRow';

const TableRequests = {
	functional: true,
	name: 'TableRequests',
	render(h, { data }) {
		return (
			<Table
				columns={ filter(canViewColumn, columns) }
				rowClassName={ always('name-test') }
				components={{
					table: CustomTable,
					header: {
						row: CustomHeaderRow,
					},
				}}
				{ ...data }
			/>
		)
	}
}

export default TableRequests
